import { useState } from 'react';

import cn from 'classnames';

import { Counter } from '../../Counter';

import { colors } from '../../../../data/constants';
import { LoaderProgress } from '../../LoaderProgress';
import { ButtonTip } from '../ButtonTip';

export const IconButtonTemplate = ({
  type = 'button',
  tooltipText = '',
  isMobileTooltip = false,
  icon,
  isSmallBorder = false,
  isSmall = false,
  isRounded = false,
  bgColor = false,
  counter = false,
  badgeCount = 0,
  disabled = false,
  isLoadingData = false,
  size,
  color,
  handleClick = () => {},
  classes = '',
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const Icon = icon;

  const isBgColor = bgColor && bgColor.length > 0;
  const hasClasses = classes && classes.length > 0;

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        className={cn(
          'relative flex justify-center items-center rounded text-black border-gray-200',
          { 'py-1.5 px-1.5 border-0': !isSmallBorder && !isSmall },
          { 'py-0.5 px-0.5': isSmallBorder },
          { 'py-0.5 px-0.5 border-0': isSmall },
          { 'py-0.5 px-0.5 border-[1px] opacity-80': isSmallBorder },
          { 'text-white': isBgColor },
          { 'rounded-full': isRounded },
          { [bgColor]: isBgColor },
          { [classes]: hasClasses },
          { 'opacity-60': disabled || isLoadingData }
        )}
        onClick={handleClick}
        type={type}
        disabled={disabled || isLoadingData}
      >
        <Icon
          size={size ? size : 20}
          color={color ? color : colors.darkGrayColor}
        />

        {isLoadingData && <LoaderProgress />}

        {counter && counter.length > 0 && <Counter amount={counter} />}

        {badgeCount > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-1 rounded-full bg-redColor text-white text-[10px] font-semibold leading-[16px] text-center pointer-events-none">
            {badgeCount}
          </span>
        )}
      </button>

      {isHovered && tooltipText && (
        <ButtonTip
          isMobileTooltip={isMobileTooltip}
          isSmallBorder={isSmallBorder}
          tooltipText={tooltipText}
        />
      )}
    </span>
  );
};
